module.exports = __webpack_public_path__ + "15e1e3023c6112617cc4fe60b23ec038.png";